import { useState } from 'preact/hooks';
import { api, me, ApiErr, type Teacher } from '@/lib/teaching/teacher-api';

export function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: Event) {
    e.preventDefault();
    setBusy(true); setError(null);
    try {
      const r = await api<{ teacher: Teacher }>('POST', '/api/auth/login', { email, password });
      me.value = r.teacher;
      const next = new URLSearchParams(location.search).get('next');
      // Only same-site paths; never an absolute URL from the query string.
      location.assign(next && next.startsWith('/') && !next.startsWith('//') ? next : '/teaching');
    } catch (err) {
      setError(err instanceof ApiErr ? err.error : 'Could not reach the server');
      setBusy(false);
    }
  }

  return (
    <div class="min-h-full grid place-items-center px-4 py-10">
      <form onSubmit={submit} class="w-full max-w-[360px] rounded-2xl border border-[var(--color-border)] bg-[var(--color-card)] p-6 flex flex-col gap-4 shadow-[0_1px_2px_rgba(16,24,40,0.04)]">
        <div class="flex items-center gap-3">
          <div class="w-9 h-9 rounded-xl bg-[var(--color-accent)] grid place-items-center font-bold text-[14px]" style={{ color: '#ffffff' }}>T</div>
          <div>
            <h1 class="text-[18px] font-semibold text-[var(--color-text)] leading-tight">Teacher OS</h1>
            <div class="text-[12px] text-[var(--color-text-muted)]">Sign in to your classes</div>
          </div>
        </div>
        <label class="flex flex-col gap-1 text-[12.5px] text-[var(--color-text-muted)]">
          Email
          <input type="email" autocomplete="username" required value={email} onInput={(e) => setEmail((e.target as HTMLInputElement).value)}
            class="h-10 rounded-lg border border-[var(--color-border)] bg-[var(--color-bg)] px-3 text-[14px] text-[var(--color-text)]" />
        </label>
        <label class="flex flex-col gap-1 text-[12.5px] text-[var(--color-text-muted)]">
          Password
          <input type="password" autocomplete="current-password" required value={password} onInput={(e) => setPassword((e.target as HTMLInputElement).value)}
            class="h-10 rounded-lg border border-[var(--color-border)] bg-[var(--color-bg)] px-3 text-[14px] text-[var(--color-text)]" />
        </label>
        {error && <div role="alert" class="text-[12.5px] text-[#b42318]">{error}</div>}
        <button type="submit" disabled={busy} class="h-10 rounded-lg bg-[var(--color-accent)] font-medium text-[14px] disabled:opacity-60" style={{ color: '#ffffff' }}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </div>
  );
}
